module.exports = __webpack_public_path__ + "static/media/marina.3e7922c6.svg";